import { render } from "./CartOverviewStatuses.vue?vue&type=template&id=dfdb6358"
import script from "./CartOverviewStatuses.vue?vue&type=script&lang=js"
export * from "./CartOverviewStatuses.vue?vue&type=script&lang=js"

import "./CartOverviewStatuses.vue?vue&type=style&index=0&id=dfdb6358&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__